/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*wizard*/
require('./components/Wizard');
require('./components/steps/Junk');
require('./components/steps/Size');
require('./components/steps/Collection');
require('./components/steps/HelpOurTeam');
require('./components/steps/Confirmation');
require('./components/steps/Payment');
require('./components/YoutubeModal');

require('./components/AdditionalPayment');
require('./components/FaqAccordion');

/* bag wizard*/
require('./components/BagWizard');
require('./components/BuyBagWizard');
/* quotes form*/
require('./components/QuotesForm');
require('./components/QuotesFormPayment');
/* admin */
require('./components/admin/JunkSize');

require('./components/PostCode');
require('./components/admin/RenderPayments');
